<template>
	<div class="row top-row">
		<div class="path-container">
			<div class="list-return">
				<router-link :to="{ name: 'home' }">{{$t("menuLabels.home")}}</router-link>
				<p>/</p>
				<span>
					<router-link v-if="hasProp(program)" :to="programRoute">{{ program.Title }}</router-link>
				</span>
			</div>
		</div>
		<div class="col-md-9">
			<div v-if="hasProp(program) && !hasProp(baseitem)">
				<div class="program-header">					
					<div v-if="isEditing">
						<font-awesome-icon icon="share-alt" class="shareLink fontAwesome fontAwesome-studiegids" :title="$t('general.shareEditorPage')" @click="getEditorShareUrl" />
					</div>
				</div>
			</div>
			<div v-if="hasProp(baseitem)">
				<div class="course-header redit">
					<div v-if="userCanEditCourses && isEditing && !futureEditMode" class="icons">
						<router-link :to="copyRoute">
							<font-awesome-icon icon="copy" class="clone-course fontAwesome fontAwesome-studiegids" :title="$t('clonePage.title')" />
						</router-link>
					</div>
					<div v-if="isEditing">
						<font-awesome-icon icon="share-alt" class="shareLink fontAwesome fontAwesome-studiegids" :title="$t('general.shareEditorPage')" @click="getEditorShareUrl" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "overview-header",
	props: ["baseitem", "program", "isEditing", "futureEditMode"],
	computed: {
		userCanEditCourses() {
			return  (this.userIsCourseEditor || this.userIsCourseFinalEditor);
		},
		copyRoute() {
			return {
				name: "clone",
			};
		},
		programListRoute(){
			var deepLink = this.$store.state.deeplink;
			if(deepLink){
				return { name: "homeDeepLinked", params: { deepLink: deepLink } };
			}
			return { name: "home" };
		},
		programRoute() {
			var slug = this.$route.params.programSlug;
			if (this.$route.params.acYear){
				return { name: "program-overview", params: { programSlug: slug, acYear: this.$route.params.acYear } };
			}else{
				return { name: "program-overview", params: { programSlug: slug } };
			}
		}
	},
	methods: {
		hasProp(prop) {
			return !(prop == null || prop == undefined);
		},
		toHelpScreen: function() {
			var model = this;
			window.open(this.$i18n.locale == "en" ? model.helpUrlEn : model.helpUrlNl, "_blank");
		},
		getEditorShareUrl(){
			this.$root.$children[0].getEditorShareUrl();
		}
	}
};
</script>
<style lang="less" scoped>
#app {
	.top-row {
		width: 100%;
		flex-direction: row;
		flex-wrap: nowrap;
	}
	h1 {
		font-family: "Open Sans", Helvetica, Arial, sans-serif;
		font-size: 26px;
		font-weight: 400;
		display: block;
		margin: 25px 0 !important;
	}

	.list-return {
		display: flex;
		justify-content: center;
		align-items: center;
		min-height: 31px; /* Align with program-header in height */
	}

	@media (max-width: 767px) {
		.list-return {
			flex-wrap: wrap;
			justify-content: start;
		}
	}

	.list-return a {
		font-size: 14px;
		display: block;
	}

	.list-return span {
		text-wrap: auto;
	}

	.list-return a:hover {
		text-decoration: none;
	}

	.list-return a::before {
		margin-left: -32px;
	}

	.list-return span {
		white-space: nowrap;
	}

	.list-return p,
	.list-return span,
	.list-return a { 
		font-size: 14px;
		line-height: 24px;
		font-weight: 400;
		color: #351FB7;
	}

	.list-return p {
		margin: 0 5px;

	}

	.icons {
		width: 20%;
		display: flex;
		justify-content: flex-end;
	}
	div.vueTitleContainer {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	div.vueTitleContainer > h1#pageTitleVue {
		padding-left: 0px;
		padding-bottom: 15px;
	}
	button.helpButton {
		margin: 0 0 25px 5px;
	}
	.shareLink,
	.clone-course {
		background-color: #007C68;
		padding: 6px;
		border-radius: 3px;
		color: #fff;
		float: right;
		height: 28px;
		width: 28px !important;
		margin-top: -2px;
		cursor:pointer;
	}
}
</style>
